// types/customer.ts
import { CustomerAddress } from "../types/address";

export enum CommunicationReason {
  SystemDefault = 0,
  NotCollected = 1,
  PhoneCall = 2,
  Email = 3,
  Letter = 4,
  Other = 11,
  OptomAudiologist = 12,
  Website = 13,
  MarkedAsDeceased = 10,
}

export enum RelationshipType {
  Unknown = "Unknown",
  Spouse = "Spouse",
  Partner = "Partner",
  Parent = "Parent",
  Child = "Child",
  Guardian = "Guardian",
  Doctor = "Doctor",
  LegalRepresentative = "LegalRepresentative",
  Sibling = "Sibling",
  Other = "Other",
}

export interface CommunicationPreference {
  allowEmail: boolean | null;
  allowSms: boolean | null;
  allowPhone: boolean | null;
  allowLetter: boolean | null;
  reason?: CommunicationReason | null;
}

export interface CareHome {
  externalId: string;
  name: string;
}

export interface CustomerPhone {
  number: string;
  isPrimary: boolean;
  type: string;
  note?: string;
}

export interface CareGiver extends CustomerDetailFormState {
  relationshipId: number;
  isPrimary: boolean;
  relationshipType: string;
}

export interface CustomerDetailFormState {
  externalId?: string;
  isActive: boolean;
  title: string;
  firstName: string;
  lastName: string;
  dateOfBirth?: string;
  patientGenderCode: string;
  isDeceased: boolean;
  deceasedDate: string | null;
  email: string;
  phones: CustomerPhone[];
  isCommercialClient: boolean;
  communicationPreference: CommunicationPreference;
  addresses: CustomerAddress[];
  careHomeExternalId?: string;
  hasMatch: boolean;
  careGivers?: CareGiver[];
}

export interface CustomerDetail extends CustomerDetailFormState {}

export interface ValidationErrors {
  [key: string]: string | undefined;
}

export interface CustomerPrecheckMatch {
  score: number;
  customerExternalId: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  email?: string;
  primaryPhone?: string;
  primaryPostcode?: string;
  isMatch: boolean;
}

export interface CustomerPrecheckMatchResponse {
  customers: CustomerPrecheckMatch[];
  duplicateCustomerMatchingThreshold: number;
}
